import e from "./_getNative.js";
var t = e, a = t(Object, "create"), v = a;
export {
  v as default
};
//# sourceMappingURL=_nativeCreate.js.map
